import { action } from 'typesafe-actions'
import { PatientsActionTypes } from './types'

export const fetchPatientsRequest = () =>
  action(PatientsActionTypes.FETCH_PATIENTS_REQUEST)

export const fetchPatientsSuccess = (data: { data: any }) =>
  action(PatientsActionTypes.FETCH_PATIENTS_SUCCESS, { data })

export const fetchPatientsFail = (message: string) =>
  action(PatientsActionTypes.FETCH_PATIENTS_FAIL, message)

export const fetchPatientRequest = () =>
  action(PatientsActionTypes.FETCH_PATIENT_REQUEST)

export const fetchPatientSuccess = (data: { data: any }) =>
  action(PatientsActionTypes.FETCH_PATIENT_SUCCESS, { data })

export const fetchPatientFail = (message: string) =>
  action(PatientsActionTypes.FETCH_PATIENT_FAIL, message)

export const fetchPatientsEstimationsRequest = () =>
  action(PatientsActionTypes.FETCH_PATIENTS_ESTIMATIONS_REQUEST)

export const fetchPatientsEstimationsSuccess = (data: { data: any }) =>
  action(PatientsActionTypes.FETCH_PATIENTS_ESTIMATIONS_SUCCESS, { data })

export const fetchPatientsEstimationsFail = (message: string) =>
  action(PatientsActionTypes.FETCH_PATIENTS_ESTIMATIONS_FAIL, message)

export const deleteUserRequest = () =>
  action(PatientsActionTypes.DELETE_USER_REQUEST)

export const deleteUserSuccess = (data: { data: any }) =>
  action(PatientsActionTypes.DELETE_USER_SUCCESS, { data })

export const deleteUserFail = (message: string) =>
  action(PatientsActionTypes.DELETE_USER_FAIL, message)

export const resetUserPasswordRequest = () =>
  action(PatientsActionTypes.RESET_USER_PASSWORD_REQUEST)

export const resetUserPasswordSuccess = (data: { data: any }) =>
  action(PatientsActionTypes.RESET_USER_PASSWORD_SUCCESS, { data })

export const resetUserPasswordFail = (message: string) =>
  action(PatientsActionTypes.RESET_USER_PASSWORD_FAIL, message)
